import { SC_SITE } from '@common/constants'
import commonServices from '@common/services'
import React, { useContext, useEffect, useState } from 'react'

interface ContextValue {
    featureFlagsLoaded: boolean
    featureFlags: string[]
}

const defaultValue: ContextValue = {
    featureFlagsLoaded: false,
    featureFlags: [],
}

const Context = React.createContext<ContextValue>(defaultValue)

interface Params {
    children: React.ReactNode
    siteType: SC_SITE
}
export const FeatureFlagProvider = ({ children, siteType }: Params) => {
    const [featureFlagsLoaded, setFeatureFlagsLoaded] = useState(defaultValue.featureFlagsLoaded)
    const [featureFlags, setFeatureFlags] = useState(defaultValue.featureFlags)

    useEffect(() => {
        const loadFeatureFlags = async () => {
            const response = await commonServices.getFeatureFlags(siteType)
            if (response.status === 200 && response.data) {
                setFeatureFlags(response.data.flags)
            }
            setFeatureFlagsLoaded(true)
        }
        loadFeatureFlags()
    }, [siteType])

    const value: ContextValue = {
        featureFlags,
        featureFlagsLoaded,
    }

    return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useFeatureFlags = () => useContext(Context)
